import React from "react";
import { connect } from "react-redux";
import {
    Container,
    Grid,
    Typography, AppBar, Toolbar, Table, TableBody, TableRow, TableCell, IconButton, Hidden,
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { ArrowBack, PictureAsPdf,} from "@mui/icons-material"
import { withTranslation } from 'react-i18next';
import clsx from "clsx";
import { history, nl2br, formatDate, authHeader, getMimeTypefromString, repairRequestDbStatuses } from '../../_helpers';
import {  userAccountRoleConstants } from "../../_constants";
import RepairRequestContactCard from "../ConstructionQuality/RepairRequestContactCard";
import { URLS } from "../../apis/urls";
import DocumentViewer from "../../components/DocumentViewer";
import NotificationPanel from "../ConstructionQuality/NotificationPanel";
import { flushSync} from "react-dom";
import i18n from "../../i18n";
import BuyerRepairRequestResolversGrid from "./BuyerRepairRequestResolversGrid";

const { webApiUrl } = window.appConfig;

const styles = theme => ({
    appBar: {
    },
    bold: {
        fontWeight: "bold"
    },
    mainContainer: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0)
        }
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        margin: theme.spacing(5, 0, 6),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(0)
        }
    },
    innerContainer: {
        padding: theme.spacing(2, 3, 4)
    },
    bigAvatar: {
        margin: 'auto',
        width: 120,
        height: 120
    },
    halfWidth: {
        width: '50%',
        verticalAlign: 'top'
    },
    button: {
        '&:hover': {
            color: theme.palette.primary.contrastText
        }
    },
    thumbnail: {
        width: '100%',
        minWidth: 100,
        height: 50,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left center',
        backgroundSize: 'contain',
        '&.big': {
            width: '100%',
            height: 0,
            padding: '50%',
            borderRadius: theme.spacing(1),
            backgroundPosition: 'center',
            backgroundColor: 'rgba(0,0,0,0.1)',
            backgroundSize: 'cover',
            cursor: "pointer"
        }
    },
    pdfTextWrapper: {
        position: "absolute",
        top: "21px",
        width: "100%",
        textAlign: 'center',
        fontSize: "24px",
        fontWeight: "bolder"
    },
    galleryImageTile: {
        position: "relative",
    },
    notificationContainer: {
        borderWidth: '1px',
        borderColor: theme.palette.grey[300],
        borderStyle: 'solid'
    }
});

const isPropertyManagerRole = (data) => (data.roles && data.roles.length === 1 && data.roles.includes(userAccountRoleConstants.propertyManager));
class Page extends React.Component {
    state = {
        repairRequest: null,
        isPropertyManager: false,
        documents: null,
        isAppoinmentCancelDialogOpen: false,
    };
    componentDidMount() {
        this.GetRepairRequestDetails();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.selected || prevProps.selected.buildingId !== this.props.selected.buildingId) {
            this.GetRepairRequestDetails();
        }
    }

    GetRepairRequestDetails() {
        let { repairRequestId } = this.props.match.params;
        const { selected, buildings } = this.props;
        if (selected && repairRequestId) {
            const url = webApiUrl + 'api/RepairRequest/GetRepairRequestDetails/' + encodeURI(repairRequestId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            flushSync(()=>{
             this.setState({
                repairRequest: null,
            });
            })    

            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                    if (findResponse.number) {
                        const building = buildings.find((x) => x.buildingId === findResponse.buildingId);
                        const projectBuilding = buildings.find((x) => (x.projectId === findResponse.projectId || x.buildingId === findResponse.buildingId));
                        const isPropertyManager = isPropertyManagerRole(building || projectBuilding);
                        flushSync(()=>{this.setState({ repairRequest: findResponse, isPropertyManager });})
                    }
                });
        }
    }

    handleFileModalClose = () => {
        flushSync(()=>{this.setState({ attachmentIndex: null, documents: null });})
    }
    handleFileModalOpen = (index, type = "image") => {
        const { repairRequest } = this.state;
        const isImage = type === "image"
        const filesAttribute = isImage ? "attachments" : "pdfAttachments"

        flushSync(()=>{
            this.setState({
            attachmentIndex: index,
            documents: [{
                uri: URLS.GET_ATTACHMENT + encodeURI(repairRequest[filesAttribute][index] ? repairRequest[filesAttribute][index].attachmentId : ''),
                fileType: getMimeTypefromString(isImage ? ".jpg" : ".pdf"), //TODO: use mimetype from server after api changes
            }]
        });
        })
    };

    handleAppoinmentCancelDialogClose = () => {
        flushSync(()=>{this.setState({ isAppoinmentCancelDialogOpen: false });})
    }
    handleAppoinmentCancelDialogOpen = () => {
        flushSync(()=>{this.setState({ isAppoinmentCancelDialogOpen: true });})
    }

    render() {
        const { t, classes, lng } = this.props;
        const { repairRequest, isPropertyManager, attachmentIndex } = this.state;
        const rrDbStatuses = repairRequestDbStatuses(i18n, lng) 

        return (
            (<Container className={classes.mainContainer} >
                <Grid container>
                    <Grid container className={classes.container} size={{xs:12}}>
                        <AppBar position="sticky" color='inherit' className={classes.appBar}>
                            <Toolbar variant="dense">
                                <IconButton
                                    color="inherit"
                                    edge="start"
                                    aria-label="go back"
                                    component="span"
                                    onClick={history.goBack}
                                    size="large">
                                    <ArrowBack />
                                </IconButton>
                                <Typography className={classes.bold}>{t('repairRequest.repairRequestDetails') + ' ' + (repairRequest ? repairRequest.number : '')}</Typography>
                            </Toolbar>
                        </AppBar>
                        {

                            repairRequest && (
                                <>
                                    <Grid
                                        container
                                        className={classes.innerContainer}
                                        sx={{
                                            rowGap: 2,
                                            alignItems: "flex-start"
                                        }}
                                        size={{
                                            xs: 12,
                                            md: 6
                                        }}>
                                        <Grid size={{xs: 12}}>
                                            <Typography variant="h6">{t('general.generalInformation')}</Typography>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" className={classes.halfWidth}>
                                                            {t('general.date') + ':'}
                                                        </TableCell>
                                                        <TableCell>{repairRequest.date && formatDate(new Date(repairRequest.date))}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.type') + ':'}
                                                        </TableCell>
                                                        <TableCell>{repairRequest.repairRequestType && repairRequest.repairRequestType}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.status') + ':'}
                                                        </TableCell>
                                                        <TableCell>{repairRequest.status && repairRequest.status}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </Grid>
                                        <Grid size={{xs: 12}}>
                                            <Typography variant="h6">{t('layout.navbar.address')}</Typography>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" className={classes.halfWidth}>
                                                            {t('general.streetAndHouseNumber') + ':'}
                                                        </TableCell>
                                                        <TableCell>{repairRequest.address && (repairRequest.address.street ? repairRequest.address.street : "") + " " + (repairRequest.address.houseNo ? repairRequest.address.houseNo : "") + (repairRequest.address.houseNoAddition ? " " + repairRequest.address.houseNoAddition : "")}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.address.postcode') + ':'}
                                                        </TableCell>
                                                        <TableCell>{repairRequest.address && repairRequest.address.postcode && repairRequest.address.postcode}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.address.city') + ':'}
                                                        </TableCell>
                                                        <TableCell>{repairRequest.address && repairRequest.address.place && repairRequest.address.place}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </Grid>

                                        <Grid size={{xs: 12}}>
                                            <Typography variant="h6">{t('repairRequest.repairRequestDescription')}</Typography>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" className={classes.halfWidth}>
                                                            {t('general.location') + ':'}
                                                        </TableCell>
                                                        <TableCell>
                                                            {repairRequest.location && repairRequest.location}
                                                            {repairRequest.drawingPinLocation && repairRequest.drawingPinLocation.dossierFileId &&
                                                                <div
                                                                    onClick={() => flushSync(()=>{this.setState({ openDrawingLocation: true });})}
                                                                    class={clsx(classes.thumbnail, 'big')} style={{
                                                                        backgroundImage: `url(${webApiUrl}api/RepairRequest/GetPinLocationImage/${repairRequest.requestId})`
                                                                    }} />
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.description') + ':'}
                                                        </TableCell>
                                                        <TableCell>{repairRequest.desc && repairRequest.desc}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.explanation') + ':'}
                                                        </TableCell>
                                                        <TableCell>{nl2br(repairRequest.detailDesc)}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            {
                                                repairRequest.completed === true &&
                                                <>
                                                    <br />
                                                    <Typography variant="h6">{repairRequest.status !== rrDbStatuses?.TURNED_DOWN ? t('repairRequest.solution') : t('general.reasonOfRejection')}</Typography>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>
                                                                    {
                                                                        nl2br(
                                                                            repairRequest.status !== rrDbStatuses.TURNED_DOWN
                                                                                ?
                                                                                (
                                                                                    repairRequest.completionText
                                                                                        ?
                                                                                        repairRequest.completionText
                                                                                        :
                                                                                        ""
                                                                                )
                                                                                :
                                                                                (
                                                                                    repairRequest.rejectionText
                                                                                        ?
                                                                                        repairRequest.rejectionText
                                                                                        :
                                                                                        ""
                                                                                )
                                                                        )
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </>
                                            }
                                        </Grid>
                                        {isPropertyManager && <Grid
                                            size={{
                                                xs: 12,
                                                md: 6
                                            }}>
                                            <Typography variant="h6">
                                                {t('general.contactDetails')}
                                            </Typography>
                                            <Grid container spacing={1}>
                                                {
                                                    repairRequest.contactInfo.buyer &&
                                                    <>
                                                        {
                                                            repairRequest.contactInfo.buyer.type === 0 &&
                                                            <>
                                                                <Grid size={{xs: 12}}>
                                                                    <RepairRequestContactCard
                                                                        hidePointOfContactCheckbox
                                                                        object={repairRequest.contactInfo.buyer.p1}
                                                                        pointOfContactType={0}
                                                                        selectedPointOfContactType={repairRequest.pointOfContact}
                                                                        subTitle={t("general.buyer1")} />
                                                                </Grid>
                                                                {
                                                                    repairRequest.contactInfo.buyer.p2 &&
                                                                    <Grid size={{xs: 12}}>
                                                                        <RepairRequestContactCard
                                                                            hidePointOfContactCheckbox
                                                                            object={repairRequest.contactInfo.buyer.p2}
                                                                            pointOfContactType={0}
                                                                            selectedPointOfContactType={repairRequest.pointOfContact}
                                                                            subTitle={t("general.buyer2")} />
                                                                    </Grid>
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>}

                                    </Grid>
                                    <Grid
                                        container
                                        className={classes.innerContainer}
                                        sx={{
                                            alignItems: "flex-start"
                                        }}
                                        size={{
                                            xs: 12,
                                            md: 6
                                        }}>
                                        <Grid className={classes.notificationContainer} size={{xs:12}}>
                                            <NotificationPanel expandViewTitle={`${repairRequest.number} - ${repairRequest.desc}`} hasChats={repairRequest.hasChats} repairRequestId={repairRequest.requestId} repairRequestNumber={repairRequest.number} resolverId={repairRequest.resolverId} hideWorkOrderLink={true} canInitiateChat={repairRequest?.canInitiateChat} hideAddChatButton  refreshParentState={()=>this.GetRepairRequestDetails()} />
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            repairRequest && ((repairRequest.attachments && repairRequest.attachments.length > 0) || (repairRequest.pdfAttachments && repairRequest.pdfAttachments.length > 0)) &&
                            <Grid container spacing={2} className={classes.innerContainer} size={{xs:12}}>
                                <Grid size={{xs: 12}}>
                                    <Typography variant="h6">{t('general.images')}</Typography>
                                </Grid>
                                {repairRequest.attachments &&
                                    repairRequest.attachments.length > 0 &&
                                    repairRequest.attachments.map((attachment, index) =>
                                        <Grid
                                            size={{
                                                xs: 6,
                                                sm: 4,
                                                md: 3,
                                                lg: 2
                                            }}>
                                            <div
                                                key={`${attachment.attachmentId}-${index}`}
                                                onClick={() => this.handleFileModalOpen(index)}
                                                class={clsx(classes.thumbnail, 'big')} style={{
                                                    backgroundImage: `url(${webApiUrl}api/home/getattachment/${attachment.attachmentId})`
                                                }} />
                                        </Grid>
                                    )
                                }
                                {repairRequest.pdfAttachments &&
                                    repairRequest.pdfAttachments.length > 0 &&
                                    repairRequest.pdfAttachments.map((file, index) =>
                                        <Grid
                                            size={{
                                                xs: 6,
                                                sm: 4,
                                                md: 3,
                                                lg: 2
                                            }}>
                                            <div className={classes.galleryImageTile} onClick={() => this.handleFileModalOpen(index, "pdf")}>
                                                <div
                                                    key={`${file.attachmentId}-${index}`}
                                                    class={clsx(classes.thumbnail, 'big')} style={{
                                                        backgroundImage: `url(${URLS.GET_ATTACHMENT_THUMBNAIL}${file.attachmentId})`
                                                    }} />
                                                <Typography className={classes.pdfTextWrapper} > <PictureAsPdf sx={{ fontSize: "40px" }} color={"error"} /></Typography>
                                            </div>
                                        </Grid>
                                    )
                                }
                            </Grid>
                        }

                        {
                            repairRequest?.resolvers &&
                            <Grid
                                className={classes.innerContainer}
                                sx={{
                                    mt: -2
                                }}
                                size={{xs:12}}>
                                <Typography variant="h6">{t('general.resolvers')}</Typography>
                              <BuyerRepairRequestResolversGrid resolvers={repairRequest?.resolvers}  />
                            </Grid>
                        }
                    </Grid>
                </Grid>
                {<DocumentViewer radius={classes.docRadius} isSurveying open={attachmentIndex != null && this.state.documents} onClose={this.handleFileModalClose} documents={this.state.documents} />}
                {
                    repairRequest && repairRequest.drawingPinLocation && repairRequest.drawingPinLocation.dossierFileId && this.state.openDrawingLocation && <DocumentViewer
                        radius={classes.docRadius}
                        isSurveying
                        open={this.state.openDrawingLocation}
                        onClose={() => { flushSync(()=>{this.setState({ openDrawingLocation: false });}) }}
                        documents={[{
                            uri: `${webApiUrl}api/RepairRequest/GetPinLocationImage/${repairRequest.requestId}`,
                            fileType: getMimeTypefromString(".jpg"), //TODO: use mimetype from server after api changes
                        }]} />
                }
            </Container>)
        );
    }
}

function mapStateToProps(state) {
    const { authentication, buildings, app, appConfig } = state;
    const { user } = authentication;
    const { lng } = appConfig;
    const { selected, all } = buildings;
    return {
        user,
        selected,
        buildings: all,
        app,
        lng
    };
}

const connectedPage = connect(mapStateToProps)(withTranslation()(withStyles(styles)(Page)));
export { connectedPage as RepairRequestDetailsPage };